import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { VueContext } from 'vue-context';
import Axios from 'axios';
import '@/assets/main.css';
let apiEndpoint = process.env.VUE_APP_API_ENDPOINT;
// let apiEndpoint = 'localhost:8000';
// let apiEndpoint = '34.234.88.33';

Axios.defaults.baseURL = `http://${apiEndpoint}/api/`;
//Axios.defaults.baseURL = 'http://34.229.12.77/api/';
// Axios.defaults.baseURL = 'http://upt-backend-app.test/api/';
// Axios.defaults.baseURL = 'http://34.234.88.33/api/';
// Axios.defaults.baseURL = 'https://upt-app.com/api/';
// Setup Axios interceptors for authentication
Axios.interceptors.request.use(config => {
    const token = store.getters['auth/getToken'];
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
});

Axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response && error.response.status === 403) {
            console.log('Forbidden: ', error.response);
            // router.push({ name: 'Forbidden' });
        }

        return Promise.reject(error);
    }
);

Vue.config.productionTip = false;
Axios.defaults.headers.common['Accept'] = 'application/json';

// Initialize the app
async function initApp() {
    // Initialize store with saved token (if any)
    await store.dispatch('auth/initializeAuth');

    // Create and mount Vue instance
    new Vue({
        router,
        store,
        vuetify,
        VueContext,
        render: h => h(App)
    }).$mount('#app');
}

// Start the app
initApp().catch(error => {
    console.error('Failed to initialize the app:', error);
});
